import { useEffect, useRef, useState } from "react";
import copy from "copy-to-clipboard";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Stack,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  Typography,
  Tooltip,
} from "@mui/material";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { stepConnectorClasses } from "@mui/material/StepConnector";
import { subHeading } from "../../Components/CustomTexts";
import MultipleAutoComplte from "../../Components/MultipleAutoComplte";
import globalColors from "../../globalColors";
import GTranslateSharpIcon from "@mui/icons-material/GTranslateSharp";
import { rowSB } from "../../GlobalStyles";
import CustomIconButton from "../../Components/CustomIconButton";
import CustomContainedButton from "../../Components/CustomContainedButton";
import { useAppDispatch, useAppSelecter } from "../../hooks/storeHooks";
import { showSnack } from "../../store/slices/constants";
import {
  getServerEnvironment,
  StopScroll,
} from "../../store/slices/constants/staticContents";
import { copyIcon } from "../../assets/svgs";
import apiRequest from "../../request/apiRequest/apiRequest";
import CustomAutocomplete from "../../Components/CustomAutocomplete";
import { allApis } from "../../request/config";
import { Backdrop, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import CustomTextField from "../../Components/CustomTextfield";
import { ObjectValues, inputProp } from "../login";
import ContentConfirmationDialog from "./ContentConfirmationDialog";
import {
  fetchReportedQuestions,
  fetchsingleReportedData,
  fetchSinlgQustion,
} from "../../store/slices/contentFeedback/contentFeedbackSlice";
import { Snackbar, Alert } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { RootState } from "../../store/store";
import CustomProgress from "../../Components/CustomProgress";
import ReportedDetails from "./ReportedDetails";
import MobileEmulator from "./Preview/MobileEmulator";
import { fetchTagsData } from "../../store/slices/exams/thunks/fetchContentData";
import { ArrowBack } from "@mui/icons-material";
import CustomCkeditor from "../../Components/CustomCkeditor";
import ConfirmationDialog from "../../Components/ConfirmationDialog";
import UpdatedQuestionPreviewWrapper from "./UpdatedQuestionPreviewWrapper";
import { replace } from "lodash";
type Item = {
  id: number;
  que: number;
};
export const CssStepperHorizontal: any = styled(Stepper)(
  () =>
    ({
      display: "flex !important",
      padding: "0 0 !important",
      flexDirection: "row !important",
      justifyContent: "space-between !important",
      backgroundColor: "transparent !important",
      width: "100% !important",
      position: "relative !important",

      "& .MuiStep-root": {
        paddingLeft: "0px !important",
        paddingRight: "0px !important",
        maxWidth: "fit-content !important",
        flex: "auto !important",
        position: "initial !important",
      },

      "& .MuiStepLabel-root": {
        display: "flex !important",
        flexDirection: "row !important",
        "& .MuiStepIcon-text": {
          fill: "white !important",
          color: "white !important",
        },
        "& .MuiStepLabel-label": {
          margin: "0 5px 0 5px !important",
        },
      },

      "& .MuiStepConnector-root": {
        left: "81.73px !important",
        right: "73.04px !important",
        top: "11.5px !important",
        width: "calc(100% - 154.77px) !important",
      },

      // Uncomment & customize if you need dashed connector line
      // "& .MuiStepConnector-line": {
      //   borderTop: `1px dashed ${globalColors.primary.black} !important`,
      //   margin: "0 8px !important",
      // },
    } as any)
);

const StyledRichTextDiv = styled("div")<{
  empty?: boolean;
  variant?: "question" | "option" | "solution";
}>(({ theme, variant = "question" }) => ({
  minHeight: "30px",
  width: "100%",
  border: "1px solid #ddd",
  borderRadius: "4px",
  boxSizing: "border-box",
  padding: "25px",
  lineHeight: 1.5,
  whiteSpace: "pre-wrap", // or "pre-line" if you want less spacing
  "& p": {
    margin: 0,
    padding: 0,
  },
  "& li": {
    margin: 0,
    padding: 0,
  },
  "&:focus": {
    outline: "none",
    borderColor: theme.palette.primary.main,
  },
  "&:empty:before": {
    content: "attr(data-placeholder)",
    color: "#aaa",
    fontStyle: "italic",
  },
  "&.tag-input": {
    minHeight: "20px",
    padding: "8px 12px",
    width: "100%",
    fontSize: "14px",
  },
  "& img": {
    ...(variant === "question" && {
      maxWidth: "600px",
      height: "auto",
      objectFit: "contain",
    }),
    ...(variant === "option" && {
      maxWidth: "300px",
      height: "auto",
      objectFit: "contain",
    }),
    ...(variant === "solution" && {
      maxWidth: "400px",
      height: "auto",
      objectFit: "contain",
    }),
  },
}));
export const RichTextInput = ({
  value,
  onChange,
  placeholder,
  className = "",
  variant = "question",
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  variant?: "question" | "option" | "solution";
}) => {
  const editorRef = useRef<HTMLDivElement>(null);
  const lastHtmlRef = useRef<string>(value);

  useEffect(() => {
    if (editorRef.current && value !== editorRef.current.innerHTML) {
      editorRef.current.innerHTML = value;
    }
  }, [value]);

  const handleInput = (e: React.FormEvent<HTMLDivElement>) => {
    const currentHtml = e.currentTarget.innerHTML;
    if (currentHtml !== lastHtmlRef.current) {
      lastHtmlRef.current = currentHtml;
      onChange(currentHtml);
    }
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const clipboardData = e.clipboardData;

    let content = clipboardData.getData("text/html");

    if (!content) {
      content = clipboardData.getData("text/plain");
      content = content.replace(/\n/g, "<br>");
    }

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = content;

    // Set image dimensions based on variant
    const images = tempDiv.getElementsByTagName("img");
    for (const img of Array.from(images)) {
      switch (variant) {
        case "question":
          img.style.maxWidth = "600px";
          break;
        case "option":
          img.style.maxWidth = "300px";
          break;
        case "solution":
          img.style.maxWidth = "400px";
          break;
      }
      img.style.height = "auto";
    }

    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      range.deleteContents();
      range.insertNode(
        document.createRange().createContextualFragment(tempDiv.innerHTML)
      );

      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    } else {
      editorRef.current?.appendChild(
        document.createRange().createContextualFragment(tempDiv.innerHTML)
      );
    }

    handleInput(e as any);
  };

  return (
    <StyledRichTextDiv
      ref={editorRef}
      contentEditable
      onInput={handleInput}
      onPaste={handlePaste}
      data-placeholder={placeholder}
      className={className}
      empty={!value}
      variant={variant}
      suppressContentEditableWarning
      data-mathjax-ignore
    />
  );
};

export const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: globalColors.primary.black,
      border: `1px dashed ${globalColors.primary.black} !important`,
    },
  },
  [`& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line`]: {
    borderColor: globalColors.primary.black,
    border: `1px solid ${globalColors.primary.black} !important`,
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: globalColors.primary.black,
      border: `1px solid ${globalColors.primary.black} !important`,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    // height: 3,
    // backgroundColor: '#eaeaf0',
    // borderRadius: 1,
    borderColor: globalColors.primary.black,
    border: `1px dashed ${globalColors.primary.black} !important`,
    ...theme.applyStyles("dark", {
      // backgroundColor: theme.palette.grey[800],
    }),
  },
}));

const EditScreen: React.FC = () => {
  const { id, contentid } = useParams();

  const examsData = useAppSelecter((state: ObjectValues) => state.exams);
  const tags_list = examsData.tags_list ?? [];

  const dispatch = useAppDispatch();

  const editData = useAppSelecter(
    (state: RootState) => state.contentFeedback.questionEditData
  );
  const row = useAppSelecter(
    (state: RootState) => state.contentFeedback.reportedData
  );
  const [value, setValue] = useState<0 | 1>(
    editData?.default_language === "english" ? 0 : 1
  );
  const [showQualityCheckBoxes, setShowQualityCheckBoxes] = useState(false);
  const [editButtonClicked, setEditButtonClicked] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [dialogActionType, setDialogActionType] = useState<
    "corrected" | "noChange"
  >("corrected");
  const [hasFetched, setHasFetched] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success"
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOpenDialog = (action: "corrected" | "noChange") => {
    setDialogActionType(action);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const getApi = (id: string) => allApis?.reportQuestion(id);
  const getReportedData = (contentid: string) =>
    allApis?.getReoprtedQueData(contentid);

  const onClear = async (data: any) => {};
  const formatPayload = (data: ObjectValues, language?: any) => {
    const newObj: any = {
      text: data.Question,
      tag:
        data["Question Tags"]?.length > 0 && language === "english"
          ? data["Question Tags"]?.map((it: any) => it.id)
          : [],
      options: [
        {
          text: data["Option A"],
          is_correct: data.correct_answer?.label === "Option A" ? true : false,
          media_urls: "",
          order: 1,
        },
        {
          text: data["Option B"],
          is_correct: data.correct_answer?.label === "Option B" ? true : false,
          media_urls: "",
          order: 2,
        },
        {
          text: data["Option C"],
          is_correct: data.correct_answer?.label === "Option C" ? true : false,
          media_urls: "",
          order: 3,
        },
        {
          text: data["Option D"],
          is_correct: data.correct_answer?.label === "Option D" ? true : false,
          media_urls: "",
          order: 4,
        },
      ],
      explanation: {
        media_urls: "",
        text: data.Explanation,
      },
      language: language,
      media_urls: "",
    };
    return newObj;
  };
  const formatPayloadTranslateEach = (data: ObjectValues, label?: string) => {
    const newObj: any = label
      ? label === "Question"
        ? { question: data.Question }
        : label === "Explanation"
        ? { explanation: data.Explanation }
        : {
            options: {
              option_1: data["Option A"],
              option_2: data["Option B"],
              option_3: data["Option C"],
              option_4: data["Option D"],
            },
          }
      : {
          question: data.Question,
          options: {
            option_1: data["Option A"],
            option_2: data["Option B"],
            option_3: data["Option C"],
            option_4: data["Option D"],
          },
          explanation: data.Explanation,
        };
    return newObj;
  };
  const formatPayloadTranslate = (data: ObjectValues, label?: string) => {
    const fields = [
      "Explanation",
      "Question",
      "Option A",
      "Option B",
      "Option C",
      "Option D",
    ];

    const mismatchedLabels = fields;
    // .filter(
    //   (field) => allSubmittedData[0][field] !== data[field]
    // );
    let newObj: any = {};

    if (mismatchedLabels.includes("Question")) {
      newObj.question = data.Question;
    }

    if (mismatchedLabels.includes("Explanation")) {
      newObj.explanation = data.Explanation;
    }

    const optionLabels = ["Option A", "Option B", "Option C", "Option D"];
    if (mismatchedLabels.some((lbl) => optionLabels.includes(lbl))) {
      newObj.options = {
        option_1: data["Option A"],
        option_2: data["Option B"],
        option_3: data["Option C"],
        option_4: data["Option D"],
      };
    }

    return newObj;
  };
  const toggleEditMode = () => {
    setIsEditable(!isEditable);
  };

  const navigateBack = () => {
    navigate("/contentFeedback");
  };
  const [openComfirm, setConfirmation] = useState<{ open: boolean; res: any }>({
    open: false,
    res: null,
  });
  const handleConfirmDialog = (remark: string, notifyUsers: boolean) => {
    const handleSuccess = (res: any) => {
      dispatch(
        showSnack({
          message:
            dialogActionType === "corrected"
              ? "Question corrected successfully!"
              : "No correction needed, Question moved to reviewed successfully!",
          severity: "success",
          open: true,
        })
      );
      setDialogOpen(false);
      setConfirmation({ open: true, res: res });
    };

    const handleError = () => {
      setSnackbarSeverity("error");
      setSnackbarMessage(
        dialogActionType === "corrected"
          ? "Failed to correct data."
          : "Failed to move the question to reviewed."
      );
    };

    setIsSubmitting(true);
    const payload = {
      rc_id: contentid,
      validator_remark: remark,
      notify_users: notifyUsers,
      review_status: "reviewed",
      action_taken:
        dialogActionType === "corrected" ? "corrected" : "no_change",
    };
    submit(payload)
      .then((res) => {
        if (res && res.error) {
        } else {
          handleSuccess(res);
        }
        return res;
      })

      .catch(handleError)
      .finally(() => {
        // .then((res) => {
        //   if (res && res.error) {
        //   } else {
        //
        //   }
        //   return res;
        // })
        // .then((res) => {
        //   if (res && res.error) {
        //   } else {
        //   }
        // })
      });
  };

  const handleChange = async (newValue: 0 | 1, no?: "No") => {
    // Set loading state first, then proceed with the rest of the logic in a separate tick
    setSubmittedData((p) => ({
      ...p,
      loader: true,
      loader_text:
        newValue === 1 && !no ? "Translating english Content to hindi." : "",
    }));
    if (newValue === 1 && !no) {
      const payload = formatPayloadTranslate(submittedData);
      if (Object.keys(payload).length > 0) {
        const response: any = await apiRequest({
          api: `content/v3/translate-text/`,
          payload: payload,
          method: "POST",
        });
        const newData = [];
        newData[0] = submittedData;
        newData[1] = getHindiData(response);
        setAllSubmittedData(newData);

        setValue(newValue);
        setSubmittedData({ ...newData[newValue], loader: false });
      } else {
        setValue(newValue);
        const newData = [...allSubmittedData];
        newData[value] = submittedData;
        setAllSubmittedData(newData);
        setSubmittedData({ ...allSubmittedData[newValue], loader: false });
      }
    } else {
      setValue(newValue);
      const newData = [...allSubmittedData];
      newData[value] = submittedData;
      setAllSubmittedData(newData);
      setSubmittedData({ ...allSubmittedData[newValue], loader: false });
    }
  };
  const getNextQUeAvailable = () => {
    const queRecords = localStorage.getItem(
      btoa(`cf-lists-${getServerEnvironment()}`)
    );
    if (queRecords && queRecords !== undefined) {
      const lists = JSON.parse(atob(queRecords)).quelist;
      const getNextObjectById = (arr: Item[], id: any): Item | null => {
        const index = arr.findIndex((item) => Number(item.id) === Number(id));
        if (index !== -1 && index < arr.length - 1) {
          return arr[index + 1];
        }
        return null; // no next object
      };

      return getNextObjectById(lists ?? [], contentid ?? 0);
    } else {
      return null;
    }
  };
  const formatForSingleLanguage = (res: any, language: any) => {
    function makePropertiesWritable(obj: {
      [x: string]: any;
      hasOwnProperty: (arg0: string) => any;
    }) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          // If the property is an object, recursively make its properties writable
          if (typeof obj[key] === "object" && obj[key] !== null) {
            if (Array.isArray(obj[key])) {
              obj[key].forEach(
                (item: {
                  [x: string]: any;
                  hasOwnProperty: (arg0: string) => any;
                }) => {
                  makePropertiesWritable(item);
                }
              );
            } else {
              makePropertiesWritable(obj[key]);
            }
          }
          // Make the property writable and configurable if it's not already defined
          if (!Object.getOwnPropertyDescriptor(obj, key)) {
            Object.defineProperty(obj, key, {
              writable: true,
              configurable: true,
            });
          }
        }
      }
    }

    const single_exam = res;
    let newSubmittedData: any = single_exam;
    makePropertiesWritable(newSubmittedData);

    allInputs.map((singleInput: inputProp) => {
      const queLanguage = language;
      switch (singleInput.label) {
        case "Explanation":
          let objs =
            Array.isArray(newSubmittedData.explanation?.translation) &&
            newSubmittedData.explanation?.translation.length > 0
              ? newSubmittedData.explanation?.translation.find(
                  (item: { language: any }) => item.language === queLanguage
                )
              : newSubmittedData.explanation?.translation;
          newSubmittedData = {
            ...newSubmittedData,
            explanation: { ...newSubmittedData.explanation, translation: objs },
          };

          break;
        case "Option A":
          let option: any =
            Array.isArray(newSubmittedData.options[0]?.translation) &&
            newSubmittedData.options[0]?.translation.length > 0
              ? newSubmittedData.options[0]?.translation?.find(
                  (item: { language: any }) => item.language === queLanguage
                )
              : newSubmittedData.options[0]?.translation;

          const objOpt = {
            translation: { ...option },
          };
          newSubmittedData = {
            ...newSubmittedData,
            options: newSubmittedData.options.map((opt: any, i: number) => {
              return i === 0 ? { ...opt, ...objOpt } : opt;
            }),
          };

          break;
        case "Option B":
          let option1: any =
            Array.isArray(newSubmittedData.options[1]?.translation) &&
            newSubmittedData.options[1]?.translation.length > 0
              ? newSubmittedData.options[1]?.translation?.find(
                  (item: { language: any }) => item.language === queLanguage
                )
              : newSubmittedData.options[1]?.translation;
          const objOpt1 = {
            translation: { ...option1 },
          };
          newSubmittedData = {
            ...newSubmittedData,
            options: newSubmittedData.options.map((opt: any, i: number) => {
              return i === 1 ? { ...opt, ...objOpt1 } : opt;
            }),
          };

          break;
        case "Option C":
          let option2: any =
            Array.isArray(newSubmittedData.options[2]?.translation) &&
            newSubmittedData.options[2]?.translation.length > 0
              ? newSubmittedData.options[2]?.translation?.find(
                  (item: { language: any }) => item.language === queLanguage
                )
              : newSubmittedData.options[2]?.translation;

          const objOpt2 = {
            translation: { ...option2 },
          };
          newSubmittedData = {
            ...newSubmittedData,
            options: newSubmittedData.options.map((opt: any, i: number) => {
              return i === 2 ? { ...opt, ...objOpt2 } : opt;
            }),
          };

          break;
        case "Option D":
          let option3: any =
            Array.isArray(newSubmittedData.options[3]?.translation) &&
            newSubmittedData.options[3]?.translation.length > 0
              ? newSubmittedData.options[3]?.translation?.find(
                  (item: { language: any }) => item.language === queLanguage
                )
              : newSubmittedData.options[3]?.translation;
          const objOpt3 = {
            translation: { ...option3 },
          };
          newSubmittedData = {
            ...newSubmittedData,
            options: newSubmittedData.options.map((opt: any, i: number) => {
              return i === 3 ? { ...opt, ...objOpt3 } : opt;
            }),
          };
          break;
        case "Question":
          let quest: any =
            Array.isArray(newSubmittedData?.translation) &&
            newSubmittedData?.translation.length > 0
              ? newSubmittedData?.translation?.find(
                  (item: { language: any }) => item.language === queLanguage
                )
              : newSubmittedData?.translation;
          if (quest) {
            quest = { ...quest };
            newSubmittedData = { ...newSubmittedData, translation: quest };
          }
          break;
      }

      return singleInput;
    });
    return newSubmittedData;
  };
  const fomratQuestionData = (id: any, que?: any, language?: any) => {
    const single_exam = que ?? editData ?? undefined;

    const newSubmittedData: any = submittedData;
    allInputs.map((singleInput: inputProp) => {
      if (singleInput.defaultValue) {
        newSubmittedData[singleInput.label] = singleInput.defaultValue.value
          ? singleInput.defaultValue.value
          : "";

        newSubmittedData[`${singleInput.label}Id`] = singleInput.defaultValue.id
          ? singleInput.defaultValue.id
          : "";
      } else if (single_exam) {
        switch (singleInput.label) {
          // case "Question Language":
          //   newSubmittedData[singleInput.label] =
          //     singleInput.list?.find((it) => it.id === current_language)
          //       ?.label ?? "";
          //   newSubmittedData[`${singleInput.label}Id`] = current_language;
          //   newSubmittedData.default_languge =
          //     current_language === single_exam.default_language;
          //   break;
          case "Question Tags":
            newSubmittedData[singleInput.label] = single_exam.tag
              ? singleInput.list?.filter((item) =>
                  single_exam.tag
                    .map((ss: any) => ss.id ?? ss)
                    .includes(item.id)
                )
              : [];

            break;
          case "Explanation":
            newSubmittedData[singleInput.label] =
              single_exam.explanation?.translation?.length > 0
                ? single_exam.explanation?.translation?.find(
                    (item: { language: any }) =>
                      item.language === newSubmittedData[`Question LanguageId`]
                  )?.text ?? ""
                : single_exam.explanation?.translation?.text ?? "";

            break;
          case "Option A":
            newSubmittedData[singleInput.label] =
              single_exam.options[0]?.translation?.length > 0
                ? single_exam.options[0]?.translation?.find(
                    (item: { language: any }) =>
                      item.language === newSubmittedData[`Question LanguageId`]
                  )?.text ?? ""
                : single_exam.options[0]?.translation?.text ?? "";
            if (single_exam.options[0]?.is_correct) {
              newSubmittedData[`correct_answer`] = singleInput;
            }
            break;
          case "Option B":
            newSubmittedData[singleInput.label] =
              single_exam.options[1]?.translation?.length > 0
                ? single_exam.options[1]?.translation?.find(
                    (item: { language: any }) =>
                      item.language === newSubmittedData[`Question LanguageId`]
                  )?.text ?? ""
                : single_exam.options[1]?.translation?.text ?? "";
            if (single_exam.options[1]?.is_correct) {
              newSubmittedData[`correct_answer`] = singleInput;
            }
            break;
          case "Option C":
            newSubmittedData[singleInput.label] =
              single_exam.options[2]?.translation?.length > 0
                ? single_exam.options[2]?.translation?.find(
                    (item: { language: any }) =>
                      item.language === newSubmittedData[`Question LanguageId`]
                  )?.text ?? ""
                : single_exam.options[2]?.translation?.text ?? "";
            if (single_exam.options[2]?.is_correct) {
              newSubmittedData[`correct_answer`] = singleInput;
            }
            break;
          case "Option D":
            newSubmittedData[singleInput.label] =
              single_exam.options[3]?.translation?.length > 0
                ? single_exam.options[3]?.translation?.find(
                    (item: { language: any }) =>
                      item.language === newSubmittedData[`Question LanguageId`]
                  )?.text ?? ""
                : single_exam.options[3]?.translation?.text ?? "";
            if (single_exam.options[3]?.is_correct) {
              newSubmittedData[`correct_answer`] = singleInput;
            }
            break;
          case "Question":
            newSubmittedData[singleInput.label] =
              Array.isArray(single_exam.translation) &&
              single_exam.translation?.length > 0
                ? single_exam.translation?.find(
                    (item: { language: any }) =>
                      item.language === newSubmittedData[`Question LanguageId`]
                  )?.text ?? ""
                : single_exam?.translation?.text ?? "";

            break;
        }
      }
      return singleInput;
    });
    if (language) {
      return {
        res: formatForSingleLanguage(single_exam, language),
        form: newSubmittedData,
      };
    } else {
      setSubmittedData(newSubmittedData);
    }
  };
  const getEditSubmittedData = (id: any, que?: any, language?: any) => {
    const single_exam = que;
    const newSubmittedData: any = submittedData;
    allInputs.map((singleInput: inputProp) => {
      if (singleInput.defaultValue) {
        newSubmittedData[singleInput.label] = singleInput.defaultValue.value
          ? singleInput.defaultValue.value
          : "";

        newSubmittedData[`${singleInput.label}Id`] = singleInput.defaultValue.id
          ? singleInput.defaultValue.id
          : "";
      } else if (single_exam) {
        switch (singleInput.label) {
          // case "Question Language":
          //   newSubmittedData[singleInput.label] =
          //     singleInput.list?.find((it) => it.id === current_language)
          //       ?.label ?? "";
          //   newSubmittedData[`${singleInput.label}Id`] = current_language;
          //   newSubmittedData.default_languge =
          //     current_language === single_exam.default_language;
          //   break;
          case "Question Tags":
            newSubmittedData[singleInput.label] = single_exam.tag
              ? singleInput.list?.filter((item) =>
                  single_exam.tag
                    .map((ss: any) => ss.id ?? ss)
                    .includes(item.id)
                )
              : [];

            break;
          case "Explanation":
            newSubmittedData[singleInput.label] =
              single_exam.explanation?.translation?.length > 0
                ? single_exam.explanation?.translation?.find(
                    (item: { language: any }) =>
                      item.language === newSubmittedData[`Question LanguageId`]
                  )?.text ?? ""
                : single_exam.explanation?.translation?.text ?? "";

            break;
          case "Option A":
            newSubmittedData[singleInput.label] =
              single_exam.options[0]?.translation?.length > 0
                ? single_exam.options[0]?.translation?.find(
                    (item: { language: any }) =>
                      item.language === newSubmittedData[`Question LanguageId`]
                  )?.text ?? ""
                : single_exam.options[0]?.translation?.text ?? "";
            if (single_exam.options[0]?.is_correct) {
              newSubmittedData[`correct_answer`] = singleInput;
            }
            break;
          case "Option B":
            newSubmittedData[singleInput.label] =
              single_exam.options[1]?.translation?.length > 0
                ? single_exam.options[1]?.translation?.find(
                    (item: { language: any }) =>
                      item.language === newSubmittedData[`Question LanguageId`]
                  )?.text ?? ""
                : single_exam.options[1]?.translation?.text ?? "";
            if (single_exam.options[1]?.is_correct) {
              newSubmittedData[`correct_answer`] = singleInput;
            }
            break;
          case "Option C":
            newSubmittedData[singleInput.label] =
              single_exam.options[2]?.translation?.length > 0
                ? single_exam.options[2]?.translation?.find(
                    (item: { language: any }) =>
                      item.language === newSubmittedData[`Question LanguageId`]
                  )?.text ?? ""
                : single_exam.options[2]?.translation?.text ?? "";
            if (single_exam.options[2]?.is_correct) {
              newSubmittedData[`correct_answer`] = singleInput;
            }
            break;
          case "Option D":
            newSubmittedData[singleInput.label] =
              single_exam.options[3]?.translation?.length > 0
                ? single_exam.options[3]?.translation?.find(
                    (item: { language: any }) =>
                      item.language === newSubmittedData[`Question LanguageId`]
                  )?.text ?? ""
                : single_exam.options[3]?.translation?.text ?? "";
            if (single_exam.options[3]?.is_correct) {
              newSubmittedData[`correct_answer`] = singleInput;
            }
            break;
          case "Question":
            newSubmittedData[singleInput.label] =
              Array.isArray(single_exam.translation) &&
              single_exam.translation?.length > 0
                ? single_exam.translation?.find(
                    (item: { language: any }) =>
                      item.language === newSubmittedData[`Question LanguageId`]
                  )?.text ?? ""
                : single_exam?.translation?.text ?? "";

            break;
        }
      }
      return singleInput;
    });
    return newSubmittedData;
    // if (language) {
    //   return {
    //     res: formatForSingleLanguage(single_exam, language),
    //     form: newSubmittedData,
    //   };
    // } else {
    //   setSubmittedData(newSubmittedData);
    // }
  };
  const getHindiData = (que: any) => {
    const single_exam = que;
    const newSubmittedData: any = allSubmittedData[1] || {};
    allInputs.map((singleInput: inputProp) => {
      if (single_exam) {
        switch (singleInput.label) {
          case "Explanation":
            if (single_exam.explanation_hi) {
              newSubmittedData[singleInput.label] = single_exam.explanation_hi;
            }

            break;
          case "Option A":
            if (single_exam.options_hi?.option_1_hi) {
              newSubmittedData[singleInput.label] =
                single_exam.options_hi.option_1_hi;
            }
            break;
          case "Option B":
            if (single_exam.options_hi?.option_2_hi) {
              newSubmittedData[singleInput.label] =
                single_exam.options_hi.option_2_hi;
            }

            break;
          case "Option C":
            if (single_exam.options_hi?.option_3_hi) {
              newSubmittedData[singleInput.label] =
                single_exam.options_hi.option_3_hi;
            }
            break;
          case "Option D":
            if (single_exam.options_hi?.option_4_hi) {
              newSubmittedData[singleInput.label] =
                single_exam.options_hi.option_4_hi;
            }
            break;
          case "Question":
            if (single_exam.question_hi) {
              newSubmittedData[singleInput.label] = single_exam.question_hi;
            }
            break;
        }
      }
      return singleInput;
    });
    return newSubmittedData;
    // if (language) {
    //   return {
    //     res: formatForSingleLanguage(single_exam, language),
    //     form: newSubmittedData,
    //   };
    // } else {
    //   setSubmittedData(newSubmittedData);
    // }
  };
  const allInputs = [
    {
      label: "Genererate Image URL",
      placeholder: "Choose image",
      value: "",
      error: false,
      helperText: " c",
      endAdornment: "",
      fieldType: "image",
      // fullWidth: true,
      api: "logo_url",
      not_required: true,
    },
    {
      label: "Question",
      fullWidth: true,
      placeholder: "Enter Question",
      value: "",
      error: false,
      helperText: "",
      endAdornment: "",
      fieldType: "cktextEditor",
      api: "question",
    },
    {
      label: "Option A",
      placeholder: "Enter Option A",
      value: "",
      error: false,
      helperText: "",
      endAdornment: "",
      fieldType: "cktextEditor",
      dataType: "option",
      api: "option1",
    },
    {
      label: "Option B",
      placeholder: "Enter Option B",
      value: "",
      error: false,
      helperText: "",
      endAdornment: "",
      dataType: "option",
      fieldType: "cktextEditor",
      api: "option2",
    },
    {
      label: "Option C",
      placeholder: "Enter Option C",
      value: "",
      error: false,
      helperText: "",
      endAdornment: "",
      dataType: "option",
      fieldType: "cktextEditor",
      api: "option3",
    },
    {
      label: "Option D",
      placeholder: "Enter Option D",
      value: "",
      error: false,
      helperText: "",
      endAdornment: "",
      dataType: "option",
      fieldType: "cktextEditor",
      api: "option4",
    },
    {
      label: "Explanation",
      fullWidth: true,
      placeholder: "Enter Explanation",
      value: "",
      error: false,
      helperText: "",
      endAdornment: "",
      fieldType: "cktextEditor",
      api: "explanation",
      not_required: true,
    },
    {
      label: "Question Tags",
      list: tags_list ?? [],
      multiple: true,
      listLabel: "name",
      error: false,
      helperText: " ",
      endAdornment: "",
      fieldType: "autocomplete",
      not_required: true,
      freeSolo: {
        dialog: true,
      },
      api: "tag",
    },
  ] as inputProp[];
  const [submittedData, setSubmittedData] = useState<ObjectValues>({
    loader: true,
  });
  const [allSubmittedData, setAllSubmittedData] = useState<ObjectValues[]>(
    editData?.languages_available?.split(",")?.map((a: any) => ({})) || []
  );
  const [questionArray, setQuestion] = useState<ObjectValues[]>([]);
  const userData = useAppSelecter(
    (state: ObjectValues) => state.userSlice.loggedUser
  );

  useEffect(() => {
    if (editData?.status === "ready") {
      setShowQualityCheckBoxes(true);
    }
    if (editData?.id && Number(id) === Number(editData?.id)) {
      fomratQuestionData(editData.id);

      const tabs = editData?.languages_available
        ? editData?.languages_available.split(",")
        : [editData?.default_language];
      // ['english', 'hindi']
      const all_languages = editData.translation
        ? editData.translation.map((s: { language: any }) => s.language)
        : [];

      //console.log("editData", all_languages)

      if (all_languages.length > 0) {
        const queArr: any = [];
        tabs?.forEach((tab: any) => {
          if (all_languages.includes(tab)) {
            queArr.push(fomratQuestionData(editData.id, null, tab));
          } else {
            queArr.push({});
          }
        });
        // all_languages.map((language: any) => {
        //   if (language) {
        //     queArr.push(fomratQuestionData(editData.id, null, language));
        //   }
        //   return language;
        // });

        setQuestion(queArr);
        let alldata: any = [];
        const eng = queArr.find(
          (s: any) => s.res.translation.language === "english"
        );
        const hindi = queArr.find(
          (s: any) => s.res.translation.language === "hindi"
        );
        if (eng) {
          if (eng && eng.res) {
            let data = { ...getEditSubmittedData(eng.res.id, eng.res) };
            alldata.push(data);
          } else {
            alldata.push({});
          }
        }

        if (hindi) {
          if (hindi && hindi.res) {
            let data = { ...getEditSubmittedData(hindi.res.id, hindi.res) };
            alldata.push(data);
          } else {
            alldata.push({});
          }
        }
        setValue(editData?.default_language === "english" ? 0 : 1);

        // let data = questionArray.map((q:any) => (getEditSubmittedData(q.res.id, q.res)))
        setAllSubmittedData(alldata);
        const newData = {
          ...alldata[editData?.default_language === "english" ? 0 : 1],
          loader: false,
        };
        setSubmittedData({ ...newData });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editData, id]);
  useEffect(() => {
    dispatch(fetchTagsData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // getApi
    if (!hasFetched) {
      dispatch(
        fetchSinlgQustion({
          api: getApi(id ?? ""),
          method: "GET",
          payload: {},
          id: id,
        })
      );
      dispatch(
        fetchsingleReportedData({
          api: getReportedData(id ?? ""),
          method: "GET",
          payload: {},
          id: id,
        })
      );
      setHasFetched(true); // Ensure it runs only once
    }

    const newData = {
      ...allSubmittedData[value],
      loader: false,
    };
    setSubmittedData({ ...newData });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFetched, dispatch]);
  const [fileInput_ref, setFileInputRef] = useState<any>({});
  const handleInputChange = (
    label: string,
    value: string | number | inputProp | null | boolean,
    id?: any
  ) => {
    if (label === "correct_answer") {
      setSubmittedData((prevDetails) => ({
        ...prevDetails,
        [label]: value,
      }));
      const newData = [...allSubmittedData];
      if (newData[1]) {
        newData[1] = { ...newData[1], [label]: value };
        setAllSubmittedData(newData);
      }
    } else {
      setSubmittedData((prevDetails) => ({
        ...prevDetails,
        [label]: value,
      }));
    }
  };
  const submit = async (payload: any) => {
    // const submitData: any = checkAllFields();
    let allData: any[] = [];
    const newData = [...allSubmittedData];
    newData[value] = submittedData;
    setAllSubmittedData(newData);

    allData = newData
      .filter((data) => Object.keys(data).length > 0)
      .map((data, i) => {
        if (formatPayload) {
          return formatPayload(data, i === 0 ? "english" : "hindi");
        }
        return data;
      });
    payload.questions = allData;
    //  console.log(allData, allSubmittedData, submittedData)
    const response: any = await apiRequest({
      api: `cms/content_feedback/reported_question/update/${
        editData?.id
      }/?status=${"published"}`,
      payload: payload,
      method: "PUT",
    });
    if (response === undefined || (response && response.error)) {
      await setSubmittedData((p) => {
        return { ...p, loader: false };
      });
      return response;
    } else {
      // console.log(response)
      const newArr: any = questionArray.map((ss) => {
        return {
          ...ss,
          res: {
            ...ss.res,
            default_language: response.default_language,
            tag: response.tag ?? [],
          },
        };
      });

      if (
        newArr.find(
          (item: { res: { translation: { id: any } } }) =>
            item.res.translation?.id === response.translation?.id
        )
      ) {
        const index = newArr.findIndex(
          (item: { res: { translation: { id: any } } }) =>
            item.res.translation?.id === response.translation?.id
        );

        if (index !== -1) {
          const updatedItem = {
            ...newArr[index],
            res: response,
          }; // Replace the `res` object with the new value
          newArr.splice(index, 1, updatedItem); // Replace the old object with the updated one
        }
      } else {
        newArr.push({ res: response, form: submittedData });
      }
      setQuestion(newArr);
      await dispatch(
        showSnack({
          message: "data submitted successfully",
          severity: "success",
          open: true,
        })
      );
      await onClear([response]);

      return response;
    }
  };
  const oneContentWidth = {
    maxWidth: "100%",
    width: "100%",
  };

  const fullWidthSx = { width: "100%" };
  const singleForm: any = (input: inputProp, i: number) => {
    const headingContent = subHeading({
      sx: { flex: 8 },
      parentSx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row",
      },
      text: `${input.label} ${input.not_required === true ? "" : "*"}`,
      icon:
        (value === 0 || value === 1) &&
        isEditable &&
        (input.label === "Question" || input.label === "Explanation") ? (
          <Box
            sx={{
              width: "fit-content",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
              {steps.length>1&&   <Tooltip title={`Translate ${input.label}`} arrow>
              <Box
                sx={{
                  margin: "0",
                  cursor: "pointer",
                  minWidth: "fit-content",
                  padding: "2px !important",
                }}
                onClick={async () => {
                  setSubmittedData((p) => {
                    return {
                      ...p,
                      loader: true,
                      loader_text: `Translating ${input.label}...`,
                    };
                  });

                  const response: any = await apiRequest({
                    api: `content/v3/translate-text/`,
                    payload: formatPayloadTranslateEach(
                      value === 0 ? submittedData : allSubmittedData[0],
                      input.label
                    ),
                    method: "POST",
                  });
                  const newData = [];
                  newData[0] =
                    value === 0 ? submittedData : allSubmittedData[0];
                  newData[1] = getHindiData(response);
                  setAllSubmittedData(newData);
                  setSubmittedData({
                    ...newData[value],
                    loader: false,
                  });
                }}
              >
                <GTranslateSharpIcon />
              </Box>
            </Tooltip>}
          </Box>
        ) : (
          input.dataType === "option" && (
            <Box
              sx={{
                // position: "absolute",
                maxWidth: "calc(100% - 72px)",
                // right: "-4px",
                // top: "0",
                zIndex: "9",
                display: "flex",
                gap: "10px",
                margin: "0 !important",
                alignItems: "center",
              }}
            >
              <Box sx={{ whiteSpace: "nowrap", overflow: "hidden" }}>
                {" "}
                {subHeading({ text: "Is Answer" })}
              </Box>
              <FormControlLabel
                sx={{ margin: "0 0 0 0 !important" }}
                label=""
                control={
                  <Checkbox
                    sx={{
                      margin: "0 !important",
                      "&.MuiButtonBase-root": {
                        padding: "0",
                      },
                    }}
                    style={{ color: "#000000" }}
                    checked={
                      submittedData &&
                      submittedData["correct_answer"] &&
                      submittedData["correct_answer"] !== null &&
                      submittedData["correct_answer"].label === input.label
                        ? true
                        : false
                    }
                    onChange={(event: any) => {
                      handleInputChange(
                        "correct_answer",
                        event.target.checked ? input : null
                      );
                    }}
                  />
                }
              />
            </Box>
          )
        ),
    });
    const sx = input.fullWidth ? fullWidthSx : oneContentWidth;
    switch (input.fieldType) {
      case "image":
        return (
          <Stack
            spacing={"5px"}
            sx={{
              marginTop: i === 1 ? "0 !important" : "",
              ...sx,
              pointerEvents: !isEditable ? "none" : "auto",
            }}
          >
            {headingContent}
            <Box
              sx={{
                border: `1px solid ${globalColors.primary.grey}`, // mostLightGrey, // sets the border color to purple
                borderRadius: "10px",
                padding: "0.69px 0.69px 0.69px 12px",
                color: globalColors.primary.black,
                ...rowSB,
              }}
            >
              {" "}
              {subHeading({
                text:
                  submittedData &&
                  submittedData[input?.label] &&
                  submittedData[input?.label]?.file
                    ? `<img src="${
                        submittedData[input.label]?.file
                      }" alt="image" style="width: 200px; height:200px; object-fit: contain"/>`
                    : "",
                parentSx: { flex: 8, width: "calc(100% - 160px)" },
                sx: {
                  whiteSpace: "nowrap",
                  width: "100%",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                },
              })}{" "}
              <input
                accept="image"
                ref={(ref) => {
                  setFileInputRef(ref);
                }}
                multiple
                id="files"
                style={{
                  visibility: "hidden",
                  width: "0",
                  maxHeight: "11px",
                }}
                type="file"
                onChange={(e: {
                  preventDefault: () => void;
                  stopPropagation: () => void;
                  target: { files: any };
                }) => {
                  e.preventDefault();
                  e.stopPropagation();

                  let fileObj = [];
                  const fileA: any[] = [];
                  fileObj.push(e.target.files);
                  for (let i = 0; i < fileObj[0].length; i++) {
                    fileA.push(fileObj[0][i]);
                  }
                  const fileUpload = async () => {
                    const res = await apiRequest({
                      form: true,
                      api: allApis.file_upload,
                      payload: {
                        parent_id: "",
                        // submittedData["Parent ClusterId"],
                        file: fileA[0],
                        created_by: userData?.id,
                        modified_by: userData?.id,
                        parent_model:
                          // content_list.find(
                          //   (item: { model: string }) =>
                          //     item.model === "question"
                          // )?.id ?? "",
                          "",
                      },
                    });

                    handleInputChange(input.label, res ?? fileA[0]);
                  };
                  fileUpload();
                }}
              />
              <Box sx={{ padding: "0 7px" }}>
                <CustomIconButton
                  content={copyIcon}
                  noHover={true}
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `<img src="${
                        submittedData[input.label].file
                      }" alt="image" style="width: 200px; height:200px; object-fit: contain"/>`
                    );

                    copy(
                      `<img src="${
                        submittedData[input.label].file
                      }" alt="image" style="width: 200px; height:200px; object-fit: contain"/>`,
                      {
                        debug: true,
                        onCopy: () => {
                          dispatch(
                            showSnack({
                              message:
                                "Image copied, paste it wherever you want it.",
                              severity: "success",
                              open: true,
                            })
                          );
                        },
                      }
                    );
                  }}
                />
              </Box>
              <label htmlFor="files" className="btn">
                <Box
                  sx={{
                    backgroundColor: "#000000", // You can customize the background color here
                    color: globalColors.primary.white,
                    textTransform: "capitalize",
                    fontWeight: 500,
                    fontSize: "0.875rem !important",
                    borderRadius: "8px",
                    lineHeight: "normal",
                    cursor: "pointer",
                    padding: "9px 10px",
                  }}
                >
                  Choose image
                </Box>
              </label>
            </Box>
          </Stack>
        );

      case "checkbox":
        return (
          <Stack
            spacing={"5px"}
            sx={{
              marginTop: i === 1 ? "0 !important" : "",
              ...sx,
              alignItems: "flex-end",
              justifyContent: "center",
              pt: "26px",
            }}
          >
            {/* {headingContent} */}
            {/* <Box sx={{minHeight:"38.86px",alignItems:"center",display:"flex"}}>
             <Checkbox checked={false}onChange={()=>{

          }}/></Box> */}
            <Box
              sx={{
                display: "flex",
                gap: "10px",
                margin: "0 10px 0 0 !important",
                alignItems: "center",
              }}
            >
              {subHeading({ text: input.label })}
              <FormControlLabel
                sx={{ margin: "0 0 0 0 !important" }}
                label=""
                control={
                  <Checkbox
                    sx={{
                      margin: "0 !important",
                      "&.MuiButtonBase-root": {
                        padding: "0",
                      },
                    }}
                    style={{ color: "#000000" }}
                    checked={submittedData["default_languge"] ? true : false}
                    onChange={(event: any) => {
                      handleInputChange(
                        "default_languge",
                        event.target.checked ? true : false
                      );
                    }}
                  />
                }
              />
            </Box>
          </Stack>
        );

      case "autocomplete":
        return (
          <Stack
            spacing={"5px"}
            sx={{
              marginTop: i === 1 ? "0 !important" : "",
              ...sx,
            }}
          >
            {headingContent}
            {input.multiple ? (
              <Stack sx={{ pointerEvents: !isEditable ? "none" : "auto" }}>
                <MultipleAutoComplte
                  {...input}
                  value={
                    submittedData && submittedData[input.label]
                      ? submittedData[input.label]
                      : []
                  }
                  onChange={(val: any) => {
                    handleInputChange(input.label, val);
                  }}
                />
              </Stack>
            ) : (
              <CustomAutocomplete
                {...input}
                list={
                  input.list && input.list.length > 0
                    ? input.list.filter((li) => {
                        return !questionArray?.find(
                          ({ res }) =>
                            (res.translation.language ??
                              res.default_language) === li.id
                        );
                      })
                    : []
                }
                value={
                  input.list?.find(
                    (s) =>
                      s[input.listLabel ?? "label"] ===
                      submittedData[input.label]
                  ) ?? null
                }
                onChange={(val: any) => {
                  handleInputChange(
                    input.label,
                    val ? val[input.listLabel ?? "label"] : null,
                    val ? val.id : undefined
                  );
                }}
              />
            )}
          </Stack>
        );
      case "cktextEditor":
        return (
          <Stack
            spacing={"5px"}
            sx={{
              marginTop: i === 1 ? "0 !important" : "",
              marginBottom: input.label === "Question" ? "0" : "20.91px",
              ...sx,
              position: "relative",
              pointerEvents: !isEditable ? "none" : "auto",
              borderRadius: "4px",
            }}
          >
            {headingContent}{" "}
            <Box>
              {/* <RichTextInput
                {...input}
                value={submittedData[input.label] ?? ""}
                onChange={(val: any) => {
                  handleInputChange(input.label, val);
                }}
              />{" "} */}
              <CustomCkeditor
                {...input}
                value={submittedData[input.label] ?? ""}
                load={submittedData.loader}
                onChange={(val: any) => {
                  if (val !== undefined) {
                    handleInputChange(input.label, val);
                  }
                }}
              />
              {input.label === "Question" &&
                (value === 0 || value === 1) &&
                isEditable && (
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
               {steps.length>1&&     <Tooltip title={`Translate Options`} arrow>
                      <Box
                        sx={{
                          minWidth: "fit-content",
                          padding: "2px !important",
                          margin: "0",
                          cursor: "pointer",
                        }}
                        onClick={async () => {
                          setSubmittedData((p) => {
                            return {
                              ...p,
                              loader: true,
                              loader_text: `Translating Options...`,
                            };
                          });
                          const response: any = await apiRequest({
                            api: `content/v3/translate-text/`,
                            payload: formatPayloadTranslateEach(
                              value === 0 ? submittedData : allSubmittedData[0],
                              "Option"
                            ),
                            method: "POST",
                          });
                          const newData = [];
                          newData[0] =
                            value === 0 ? submittedData : allSubmittedData[0];
                          newData[1] = getHindiData(response);
                          setAllSubmittedData(newData);
                          setSubmittedData({
                            ...newData[value],
                            loader: false,
                          });
                        }}
                      >
                        <GTranslateSharpIcon />
                      </Box>
                    </Tooltip>}
                  </Box>
                )}
            </Box>
          </Stack>
        );
      case "extra":
        return (
          <Stack
            spacing={"5px"}
            sx={{
              marginTop: i === 1 ? "0 !important" : "",
              marginBottom: "20.91px",
              ...sx,
              // height: "100px",
            }}
          ></Stack>
        );
      default:
        return <Grid item xs={singlexs} display="flex" key={"default"}></Grid>;
    }
  };
  const singlexs = 6;
  const allFormComp: any = (list: inputProp[], index: number) => {
    return list?.map((input: inputProp, i: number) => {
      return (
        <Grid
          item
          xs={input.fullWidth ? 12 : singlexs}
          display="flex"
          key={`${input.label}=${i}`}
          sx={
            input.fullWidth ? {} : { maxWidth: "calc(50% - 7.5px) !important" }
          }
          {...input?.grid}
        >
          {input.label === "Question Tags" && index > 0 ? (
            <></>
          ) : (
            singleForm(
              showQualityCheckBoxes ? { ...input, disabled: true } : input,
              i
            )
          )}
        </Grid>
      );
    });
  };

  const checkForMissingVal = (object: any): boolean => {
    let notAllFilled = false;
    for (const [key, value] of Object.entries(object).filter(
      ([key, value]) => key !== "loader"
    )) {
      const inputField = allInputs.find((a: any) => a.label === key);
      if (!inputField?.not_required) {
        if (value === null || value === undefined || value === "") {
          notAllFilled = true;
          break;
        }
      }
      if (key === "correct_answer") {
        if (value === null || value === undefined || value === "") {
          notAllFilled = true;
          break;
        }
      }
    }
    return notAllFilled || !object.hasOwnProperty("correct_answer");
  };

  const isAllMandatoryFieldsFilled = (): boolean => {
    let isMissing: boolean[] = [false, false];
    allSubmittedData &&
      allSubmittedData?.forEach((a, index) => {
        if (!a || Object.entries(a).length === 0) {
          isMissing[index] = true;
          return true;
        }
        isMissing[index] = checkForMissingVal(a);
      });

    const checkForCurrentTab =
      submittedData && checkForMissingVal(submittedData);
    if (checkForCurrentTab) {
      isMissing[value] = true;
    } else {
      const newData = [...allSubmittedData];
      newData[value] = submittedData;
      newData?.forEach((a) => {
        isMissing[value] = false;
        if (!a || Object?.entries(a)?.length === 0) {
          isMissing[value] = true;
          return true;
        }
        isMissing[value] = checkForMissingVal(a);
      });
    }
    return isMissing.some((a) => a);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const navigate = useNavigate();

  const steps = editData?.languages_available?.includes("hindi")
    ? ["English", "Hindi"]
    : ["English"];

  const bottomHeader = (val: 0 | 1) => {
    return submittedData["Question"] === undefined && isEditable === false ? (
      ""
    ) : (
      <Box
        sx={{
          width: "100%",
          ...rowSB,
          padding: "8px",
          boxSizing: "border-box",
          bgcolor: "background.paper",
          borderRadius: "8px",
          border: "1px solid #ccc",
        }}
      >
        <Box sx={{ display: "flex", width: "calc(100% - 202.33px)" }}>
          {value + 1 === steps.length && steps.length > 1 ? (
            <CustomIconButton
              key="back"
              variant="outlined"
              content="Back"
              icon={<ArrowBack sx={{ height: "16px" }} />}
              sx={{ minWidth: "fit-content", mr: "5px" }}
              onClick={() => {
                handleChange(0);
              }}
            />
          ) : (
            ""
          )}
        </Box>
        <Box sx={{ minWidth: "fit-content" }}>
          {editButtonClicked ? (
            <></>
          ) : (
            // questionStatus != "unpublished" &&
            <CustomContainedButton
              key="Save As Draft"
              otherProps={{
                // disabled: submittedData && Object.values(submittedData).every(c => c === undefined || c === null || c === ''),
                onClick: () => {
                  toggleEditMode();
                  setEditButtonClicked(true);
                },
                sx: { minWidth: "fit-content" },
              }}
              content={<EditNoteOutlinedIcon sx={{ height: "16px" }} />}
              icon="Edit"
            />
          )}{" "}
          {value + 1 === steps.length ? (
            editButtonClicked ? (
              <CustomContainedButton
                otherProps={{
                  disabled: isAllMandatoryFieldsFilled(),
                  onClick: () => {
                    handleOpenDialog("corrected");
                  },
                  sx: { minWidth: "fit-content" },
                }}
                loading={
                  submittedData &&
                  submittedData.loader &&
                  submittedData.clicked_button_type
                    ? submittedData.loader
                    : undefined
                }
                icon="Mark as Corrected"
                content={
                  <PlaylistAddCheckOutlinedIcon sx={{ height: "16px" }} />
                }
              />
            ) : (
              <CustomContainedButton
                otherProps={{
                  disabled: isAllMandatoryFieldsFilled(),
                  onClick: () => {
                    handleOpenDialog("noChange");
                  },
                  sx: { minWidth: "fit-content" },
                }}
                loading={
                  submittedData &&
                  submittedData.loader &&
                  submittedData.clicked_button_type
                    ? submittedData.loader
                    : undefined
                }
                content={
                  "Mark as no change"
                  // showQualityCheckBoxes ? "Mark As Approved"
                  //   : questionStatus === "unpublished" ? "Save and Exit" : "Mark As Ready"
                }
              />
            )
          ) : (
            <CustomContainedButton
              otherProps={{
                disabled: false,
                onClick: () => {
                  handleChange(1, "No");
                },
                sx: { minWidth: "60px" },
              }}
              icon="Next"
              content={<ArrowForwardIcon sx={{ height: "16px" }} />}
            />
          )}
          {value + 1 === steps.length ? (
            ""
          ) : (
            <CustomContainedButton
              otherProps={{
                disabled: false,
                onClick: () => {
                  handleChange(1);
                },
                sx: { minWidth: "60px", ml: "8px" },
              }}
              icon={
                <>
                  <GTranslateSharpIcon sx={{ height: "16px" }} /> Translate{" "}
                  <ArrowForwardIcon sx={{ height: "16px" }} />
                </>
              }
              content={"Next"}
            />
          )}
          {openComfirm.open && (
            <ConfirmationDialog
              title={"Reviewed Question Successfully."}
              content={
                <Box
                  sx={{
                    height: "calc(100dvh - 190.67px)",
                    minHeight: "calc(100dvh - 190.67px)",
                    boxSizing: "border-box",
                    maxWidth: "500px",
                  }}
                >
                  <UpdatedQuestionPreviewWrapper
                    questionEditData={openComfirm.res}
                  />
                </Box>
              }
              customWidth="fit-content"
              yesButtonText="Review Next Question"
              noButtonText="Go to List"
              actions={!getNextQUeAvailable() ? [] : undefined}
              open={openComfirm.open}
              onClose={() => {
                dispatch(fetchReportedQuestions({ state: "pending", page: 0 }));
                navigateBack();
                setConfirmation({ open: false, res: null });
                setSnackbarOpen(true);
                setDialogOpen(false);
                setIsSubmitting(false);
                localStorage.removeItem(
                  btoa(`cf-lists-${getServerEnvironment()}`)
                );
              }}
              onSubmit={async () => {
                const singleQue = getNextQUeAvailable();
                if (singleQue) {
                  // ✅ Example usage:
                  if (singleQue) {
                    navigate(
                      `/contentFeedback/editScreen/${singleQue?.que}/${
                        singleQue?.id ?? ""
                      }`,
                      { replace: true }
                    );
                    setHasFetched(false);
                    setSubmittedData({ loader: true });
                    await setConfirmation({ open: false, res: null });
                    await setSnackbarOpen(true);
                    await setDialogOpen(false);
                    await setIsSubmitting(false);
                  }
                  // 👉 { id: 678, que: 49507 }
                }
                // ,
                // btoa(JSON.stringify({quelist:(reportedQuestions.results ?? []),
                //   // mast
                // }))
              }}
            />
          )}
          <ContentConfirmationDialog
            open={isDialogOpen}
            onClose={handleCloseDialog}
            onConfirm={handleConfirmDialog}
            actionType={dialogActionType}
            // row={row}
            isSubmitting={isSubmitting}
          />
        </Box>
      </Box>
    );
  };
  const content = (val: 0 | 1) => {
    return submittedData["Question"] === undefined && isEditable === false ? (
      <Backdrop
        style={{ color: "#fff", zIndex: 9999999, width: "100%" }}
        open={true}
      >
        {" "}
        <CustomProgress
          sx={{
            height: "50px !important",
            width: "50px !important",
            color: "white",
          }}
        />
      </Backdrop>
    ) : (
      [val]?.map((index: number) => (
        <Box
          key={index}
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
          }}
        >
          <Box
            className="scrollBluePrimarythin"
            sx={{
              overflowY: "scroll",
              overflowX: "hidden",
              height: "100%",
            }}
          >
            {" "}
            <Grid
              container
              key={"QuestionFormComponentMock"}
              rowSpacing={1}
              columnGap={""}
              sx={{
                gap: "0 15px",
                padding: "24px 19px",
                minHeight: "100%",
                width: "100%",
                boxSizing: "border-box",
                // borderRadius: "4px",
                // border: "2px solid black",
                // margin: "10px",
                // height: "fit-content",
                // position: "relative",
              }}
            >
              {allFormComp(allInputs, index)}
            </Grid>
          </Box>
        </Box>
      ))
    );
  };
  return (
    <Stack height="100%" width="100%">
      {submittedData.loader === true ? (
        <Backdrop
          open={true}
          style={{
            color: "#fff",
            zIndex: 9999999,
            backdropFilter: "blur(3px)", // subtle blur
          }}
        >
          <Stack spacing={2} alignItems="center" justifyContent="center">
            <CustomProgress
              sx={{
                height: 60,
                width: 60,
                color: "white",
              }}
            />
            <Typography
              variant="h6"
              sx={{ fontWeight: 500, color: "white", letterSpacing: 0.5 }}
            >
              {submittedData.loader_text ?? "Loading..."}
            </Typography>
          </Stack>
        </Backdrop>
      ) : (
        ""
      )}
      <Stack
        margin={"6px 8px 8px"}
        sx={{
          // overflow: "hidden",
          height: "calc(100% - 14px)",
          width: "calc(100% - 16px)",
          background: "transparent",
        }}
        direction={"row"}
        spacing={"10px"}
      >
        <style>{`img {max-width:100%}`}</style>
        {/* left */}

        {submittedData["Question"] === undefined && isEditable === false ? (
          <Backdrop
            style={{ color: "#fff", zIndex: 9999999, width: "100%" }}
            open={true}
          >
            {" "}
            <CustomProgress
              sx={{
                height: "50px !important",
                width: "50px !important",
                color: "white",
              }}
            />
          </Backdrop>
        ) : (
          <Box
            style={{
              width: "calc(100% - 408px)",
              minWidth: "calc(60% - 8px)",
              height: "100%",
              maxWidth: "350px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                mb: "10px",
                ...rowSB,
                padding: "8px",
                boxSizing: "border-box",
                bgcolor: "background.paper",
                borderRadius: "8px",
                border: "1px solid #ccc",
              }}
            >
              {row !== null && (
                <ReportedDetails
                  sx={{ width: "100%" }}
                  heading={
                    <Box
                      sx={{
                        width: "fit-content",
                        mr: "2px",
                        display: "flex",
                        flexDirection: "row",
                        maxHeight: "24px",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        onClick={() => {
                          localStorage.removeItem(
                            btoa(`cf-lists-${getServerEnvironment()}`)
                          );
                          navigate("/contentFeedback");
                        }}
                        sx={{
                          cursor: "pointer",
                          width: "fit-content",
                          mr: "2px",
                          maxHeight: "24px",
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        <ArrowBack sx={{ maxHeight: "16px", width: "16px" }} />
                      </Box>
                      Edit
                    </Box>
                  }
                  row={row}
                  content={
                    <Box
                      sx={{
                        width:
                          value + 1 === steps.length && steps.length > 1
                            ? "calc(100% - 60px)"
                            : "100%",
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {" "}
                      <Box
                        maxWidth="400px"
                        width={"calc(100% - 10px)"}
                        margin="0 5px"
                      >
                        <CssStepperHorizontal
                          activeStep={value}
                          alternativeLabel
                          connector={<ColorlibConnector />}
                        >
                          {steps.map((label, i) => (
                            <Step key={label}>
                              <StepLabel>{label}</StepLabel>
                            </Step>
                          ))}
                        </CssStepperHorizontal>
                      </Box>
                    </Box>
                  }
                  reportid={contentid ?? ""}
                />
              )}
            </Box>
            {submittedData["Question"] === undefined && isEditable === false ? (
              ""
            ) : (
              <Paper
                style={{
                  width: "100%",
                  minWidth: "100%",
                  height: "calc(100% - 118.33px)",
                  borderRadius: "8px",
                  border: "1px solid black",
                  padding: "8px 0",
                  boxSizing: "border-box",
                  marginBottom: "8px",
                  position: "relative",
                }}
              >
                {" "}
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  sx={{
                    position: "absolute",
                    top: "-9px",
                    left: 16,
                    bgcolor: "white !important",
                    zIndex: "99",
                    px: 1,
                    borderRadius: "8px",
                    border: "1px solid black",
                  }}
                >
                  Question
                </Typography>
                {content(value)}
              </Paper>
            )}
            {bottomHeader(value)}
          </Box>
        )}
        {/* preview */}
        <Grid
          container
          width="40%"
          maxWidth="400px"
          key={"QuestionFormComponentMock"}
          rowSpacing={1}
          columnGap={""}
          sx={{
            gap: "0 15px",
            paddingRight: "0",
            paddingTop: "0",
            height: "100%",
          }}
        >
          {submittedData["Question"] === undefined && isEditable === false ? (
            ""
          ) : (
            <MobileEmulator
              submittedData={submittedData}
              languge={{
                handleQuizLanguageToggled: () => {},
                languages: steps,
                selectedLang: value === 0 ? steps[0] : steps[1],
              }}
            />
          )}
        </Grid>
      </Stack>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Stack>
  );
};

export default EditScreen;
